import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Mapboxpage from "../Mapboxpage";
import { db } from '../../firebase-config';
import { collection, getDocs, query, where } from 'firebase/firestore';
import airportimg from "../images/airport_transfer_new2.jpg"
import evento from "../images/icons8-event-accepted-100.png";
import eventt from "../images/icons8-event-professional-100.png";
import eventth from "../images/icons8-event-service-100.png";
import CircularProgress from "@mui/material/CircularProgress";

const EventTransportation = () => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const [eventtransportationservices, eventtransportationServices] = useState([]);
  // console.log("eventtransportationdata,",eventtransportation)
  const headerData = eventtransportationservices[0];
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const q = query(
          collection(db, "ownerPageDatas"),
          where("selectedmenutype", "==", "eventtransportation")
        );
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        eventtransportationServices(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false); // ✅ important
      }
    };
    fetchServices();
  }, []);

    // 👇 Loader here
  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#45B2F7" }} />
      </div>
    );
  }

  return (
    <>
      {/* HERO SECTION */}
     <div
        className="mainhero-container"
        style={{
          backgroundImage: `url(${headerData?.headerimage || airportimg})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="mainhero-content">
          {/* <h1>
   <span style={{ color: "#45B2F7" }}>Luxury</span> Airport Transfers Service
 </h1> */}
          <h1>
            <span style={{ color: "#45B2F7" }}>
              {headerData?.headerTitle?.split(" ")[0] || " Luxury Event Transportation"}
            </span>{" "}
            {headerData?.headerTitle?.split(" ").slice(1).join(" ") || "Airport Transfers Service"}
          </h1>
          <p>
            {headerData?.headerDescription || " Elegant and reliable travel solutions for weddings, corporate events, and VIP occasions.."}
          </p>
        </div>
        <Mapboxpage />
      </div>
      <br />
      {/* INFO CARDS */}

      <div className="cards-containerairport">
        <div className="info-card">
          <div className="card-text">
            <img src={evento} alt="service" className="card-logo" />
            <br />
            <h3>Punctual & Reliable Service</h3>
            <p>
              At MAS Mobility Services, we provide dependable event transportation solutions with timely pickups and seamless travel coordination. From weddings to corporate gatherings, we ensure every guest arrives safely, comfortably, and on schedule.
            </p>
          </div>
        </div>
        <div className="info-card">
          <div className="card-text">
            <img src={eventt} alt="service" className="card-logo" />
            <br />
            <h3>Professional Chauffeurs</h3>
            <p>
              MAS Mobility Services offers highly trained and courteous chauffeurs who deliver a premium travel experience for all event transportation needs. Our drivers prioritize professionalism, safety, and exceptional customer service throughout your journey.
            </p>
          </div>
        </div>

        <div className="info-card">
          <div className="card-text">
            <img src={eventth} alt="service" className="card-logo" />
            <br />
            <h3>Comfortable & Spacious Vehicles</h3>
            <p>
              Travel in comfort with the premium fleet of MAS Mobility Services. Whether it’s a wedding celebration, business event, concert, or private function, our spacious luxury vehicles provide smooth, stylish, and stress-free transportation for individuals and groups.
            </p>
          </div>
        </div>

      </div>
      <br />
      <div>
        {loading ? (
          <div className="skeleton-card">loading ....</div>
        ) : eventtransportationservices?.length === 0 ? (
          <h2 style={{ textAlign: "center" }}>No data found</h2>
        ) : (
          eventtransportationservices?.map((service, index) => (
            <div
              key={service.id}
              className={`service-section ${index % 2 !== 0 ? "reverse" : ""
                }`}
            >
              {/* IMAGE */}
              <div
                className="service-image"
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <img src={service.image} alt={service.description} />
              </div>

              {/* CONTENT */}
              <div className="service-content">
                <h2>{service.description}</h2>

                <ul className="service-list">
                  {service?.content
                    ?.split(".")
                    .filter((item) => item.trim() !== "")
                    .map((item, index) => (
                      <li key={index}>
                        {item.trim()}
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default EventTransportation;